"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  createLaunchlabDraftStorage,
  IDX_LAUNCHLAB_CREATE_DRAFT_KEY,
} from "@/lib/idx-launchlab/create-draft-storage";
import { sanitizeLaunchlabSymbol } from "@/lib/idx-launchlab/token-field-limits";

export { IDX_LAUNCHLAB_CREATE_DRAFT_KEY };

const initialToken = {
  name: "",
  symbol: "",
  description: "",
  image: "",
  previewLogoDataUrl: undefined,
  previewBannerDataUrl: undefined,
  socialWebsite: "",
  socialTwitter: "",
  socialTelegram: "",
  mintAddress: undefined,
  metadataUri: undefined,
  pinnedImageUri: undefined,
  pinnedPayloadKey: undefined,
  initialBuySol: "",
};

function mergeNewToken(persistedToken) {
  if (persistedToken?.mintAddress?.trim()) {
    return { ...initialToken };
  }
  const merged = {
    ...initialToken,
    ...(persistedToken ?? {}),
  };
  merged.symbol = sanitizeLaunchlabSymbol(merged.symbol);
  return merged;
}

export const useLaunchlabCreateStore = create(
  persist(
    (set) => ({
      step: 1,
      formResetKey: 0,
      newToken: { ...initialToken },
      txStatus: "idle",
      txError: null,
      txSignatures: [],
      setStep: (step) => set({ step }),
      updateNewToken: (data) =>
        set((state) => ({
          newToken: {
            ...state.newToken,
            ...data,
            ...(data.symbol !== undefined
              ? { symbol: sanitizeLaunchlabSymbol(data.symbol) }
              : {}),
          },
        })),
      setTxStatus: (txStatus) => set({ txStatus }),
      setTxError: (txError) => set({ txError }),
      setTxSignatures: (txSignatures) => set({ txSignatures }),
      reset: () =>
        set((state) => ({
          step: 1,
          formResetKey: state.formResetKey + 1,
          newToken: { ...initialToken },
          txStatus: "idle",
          txError: null,
          txSignatures: [],
        })),
    }),
    {
      name: IDX_LAUNCHLAB_CREATE_DRAFT_KEY,
      storage: createLaunchlabDraftStorage(
        typeof window === "undefined"
          ? {
              getItem: () => null,
              setItem: () => {},
              removeItem: () => {},
            }
          : window.localStorage,
      ),
      partialize: (state) => ({
        step: state.step,
        newToken: {
          ...state.newToken,
          mintAddress: undefined,
        },
      }),
      merge: (persistedState, currentState) => {
        const persisted = persistedState ?? {};
        const persistedToken = persisted.newToken;
        const launched = Boolean(persistedToken?.mintAddress?.trim());
        return {
          ...currentState,
          step: launched ? 1 : typeof persisted.step === "number" ? persisted.step : currentState.step,
          newToken: launched ? { ...initialToken } : mergeNewToken(persistedToken),
          txStatus: "idle",
          txError: null,
          txSignatures: [],
        };
      },
    },
  ),
);
